export class BNLAccordian {
	init() {
		const accordians = document.querySelectorAll<HTMLElement>(".accordian");

		accordians.forEach(accordian => {
			const expand = accordian.querySelector<HTMLButtonElement>(".expand");
			const collapse =
				accordian.querySelector<HTMLButtonElement>(".collapse");
			const contents = accordian.querySelector<HTMLElement>("section");

			if (!contents || !collapse || !expand) {
				return;
			}

			if (!accordian.classList.contains("expanded")) {
				contents.style.height = "0px";
			} else {
				contents.style.height = this.computeAccordianHeight(contents);
			}

			window.addEventListener("resize", () => {
				if (accordian.classList.contains("expanded")) {
					contents.style.height = this.computeAccordianHeight(contents);
				} else {
					contents.style.height = "0px";
				}
			});

			expand.addEventListener("click", () => {
				requestAnimationFrame(() => {
					contents.style.height = this.computeAccordianHeight(contents);
				});
				accordian.classList.add("expanded");
			});

			collapse.addEventListener("click", () => {
				contents.style.height = "0px";
				accordian.classList.remove("expanded");
			});
		});
	}

	private computeAccordianHeight(contents: HTMLElement) {
		const childrenHeight = Array.from(contents.children).reduce((computedHeight, node) => {
			computedHeight += parseInt(getComputedStyle(node).height);
			return computedHeight;
		}, 0);

		return `${childrenHeight}px`;
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const accordian = new BNLAccordian();
	accordian.init();
});
